import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import MultiPartQuestion from "apps/questions/components/MultiPartQuestion/";
import ButtonsWrapper from "./ButtonsWrapper";
import Buttons from "./Buttons";

class MultiPartQuestionWrapper extends Component {
	static propTypes = {
		question: PropTypes.object,
		isLoading: PropTypes.bool.isRequired,
		isProcessing: PropTypes.bool,
		onSubmit: PropTypes.func.isRequired,
		onSkip: PropTypes.func.isRequired,
		onDisplayQuestion: PropTypes.func.isRequired,
		onSelectAnswer: PropTypes.func.isRequired,
		onToggleAcceptedAnswer: PropTypes.func.isRequired,
		onSetImportance: PropTypes.func.isRequired,
		onTogglePrivacy: PropTypes.func.isRequired,
		onChangeExplanation: PropTypes.func.isRequired,
		targetAnswerMode: PropTypes.bool.isRequired,
		targetAnswerModeOnCancel: PropTypes.func,
	}

	static defaultProps = {
		targetAnswerModeOnCancel: null,
	}

	state = {
		transitionIsEnabled: false,
	};

	componentDidMount() {
		if (this._hasAnswers(this.props.question)) {
			this._enableTransition();
		}
	}

	componentDidUpdate(prevProps) {
		if (
			!this._hasAnswers(prevProps.question) &&
			this._hasAnswers(this.props.question)
		) {
			this._enableTransition();
		}
	}

	_enableTransition = () => {
		this.setState({ transitionIsEnabled: true });
	}

	_hasAnswers = (question) => {
		let res = false;

		if (!question || !question.answers) {
			return res;
		}

		question.answers.forEach((answer) => {
			if (answer.text !== "") {
				res = true;
				return;
			}
		});

		return res;
	}

	_canSubmit = () => {
		const { question } = this.props;
		const { answers } = question;

		const hasAnswer = answers.reduce((memo, { isSelected }) => {
			if (isSelected) {
				return true;
			}

			return memo;
		}, false);

		const hasAcceptedAnswers = answers.reduce((memo, { isAccepted }) => {
			if (isAccepted) {
				return true;
			}

			return memo;
		}, false);

		const hasImportance = !!question.importance;

		return hasAnswer &&
			hasAcceptedAnswers &&
			hasImportance &&
			!question.cantReanswer;
	}

	render() {
		const {
			question,
			isLoading,
			isProcessing,
			onSubmit,
			onSkip,
			onDisplayQuestion,
			onSelectAnswer,
			onToggleAcceptedAnswer,
			onSetImportance,
			onTogglePrivacy,
			onChangeExplanation,
			targetAnswerMode,
			targetAnswerModeOnCancel,
		} = this.props;

		const { transitionIsEnabled } = this.state;

		const transitionName = transitionIsEnabled ?
			"questionspage-question" :
			"questionspage-question-disabled";

		return (
			<Fragment>
				<CSSTransitionGroup
					transitionName={transitionName}
					transitionEnterTimeout={300}
					transitionLeaveTimeout={300}
					component={Fragment}
				>
					<MultiPartQuestion
						{...question}

						key={question.id}
						isLoading={isLoading}
						onDisplayQuestion={onDisplayQuestion}
						onSelectAnswer={onSelectAnswer}
						onToggleAcceptedAnswer={onToggleAcceptedAnswer}
						onSetImportance={onSetImportance}
						onTogglePrivacy={onTogglePrivacy}
						onChangeExplanation={onChangeExplanation}
					/>
				</CSSTransitionGroup>

				<ButtonsWrapper>
					<Buttons
						onSkip={onSkip}
						onSubmit={onSubmit}
						canSubmit={this._canSubmit()}
						targetAnswerMode={targetAnswerMode}
						targetAnswerModeOnCancel={targetAnswerModeOnCancel}
						isProcessing={isProcessing}
					/>
				</ButtonsWrapper>
			</Fragment>
		);
	}
}

export default MultiPartQuestionWrapper;



// WEBPACK FOOTER //
// ./src/apps/questions/components/MultiPartQuestionWrapper/index.jsx